<template>
  <v-container class="custom-container">
    <v-row dense>
      <v-col cols="12">
        <v-card class="px-5 pt-5" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
          <v-row dense>
            <v-col cols="12" :sm="$canRoute('broker-account') !== 1 ? 12 : 10">
              <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search bank ..." single-line solo
                hide-details class="custom-v-input"></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" v-if="$canRoute('broker-account') === 1">
              <v-dialog transition="scale-transition" origin="center center" max-width="550" v-model="dialog"
                content-class="deposit-withdraw-popup marketingPopup">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn large tile block elevation="0" @click="clear" class="ma-0 text-capitalize btn-account" color="greenMain"
                    height="48px" v-bind="attrs" v-on="on">
                    Add New Bank
                  </v-btn>
                </template>

                <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                  ">
                  <v-card-title class="pb-3 text-left justify-start pl-3">
                    Add New Bank
                  </v-card-title>
                  <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                    You Can Add new bank account from here
                  </v-card-subtitle>
                  <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                    ">
                    <v-row>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Bank Name*</legend>
                          <v-text-field v-model="bankData.beneficiary_bank_name" label="ENTER YOUR BANK NAME" single-line
                            solo hide-details class="custom-select"></v-text-field>
                        </fieldset>
                        <span v-if="
                          !bankData.beneficiary_bank_name &&
                          errors.beneficiary_bank_name
                        " class="error-message">{{ errors.beneficiary_bank_name }}</span>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Account Holder Name*</legend>
                          <v-text-field v-model="bankData.beneficiary_name" label="ENTER YOUR ACCOUNT NAME" single-line
                            solo hide-details class="custom-select"></v-text-field>
                        </fieldset>
                        <span v-if="
                          !bankData.beneficiary_name &&
                          errors.beneficiary_name
                        " class="error-message">{{ errors.beneficiary_name }}</span>
                      </v-col>
                      <!-- New UPI ADD -->
                      <v-col cols="12">
                        <fieldset>
                          <legend>UPI Address*</legend>
                          <v-text-field v-model="bankData.upi" label="ENTER YOUR UPI ADDRESS" single-line
                            solo hide-details class="custom-select"></v-text-field>
                        </fieldset>
                        <span v-if="
                          !bankData.upi &&
                          errors.upi
                        " class="error-message">{{ errors.upi }}</span>
                      </v-col>
                      <!-- New UPI ADD -->
                      <v-col cols="12">
                        <fieldset>
                          <legend>Account Number*</legend>
                          <v-text-field v-model="bankData.beneficiary_account" label="ENTER YOUR BANK A/C NUMBER" single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                        <span v-if="
                          !bankData.beneficiary_account &&
                          errors.beneficiary_account
                        " class="error-message">{{ errors.beneficiary_account }}</span>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <fieldset>
                          <legend>Bank Country*</legend>
                          <v-autocomplete v-model="bankData.countryAccess"
                            :items="[{ id: 'all', name: 'All Countries' }, ...countries]" label="Country Access"
                            item-text="name" item-value="id" multiple chips deletable-chips single-line solo
                            class="custom-select" @change="handleCountrySelection">
                          </v-autocomplete>
                          <span v-if="!bankData.countryAccess && errors.countryAccess"
                            style="color: red; font-size: 12px">
                            {{ errors.countryAccess }}
                          </span>
                        </fieldset>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Bank Logo*</legend>
                          <v-file-input v-model="bankData.methods_logo_url" label="Choose file (Max Size 2MB)"
                            single-line solo prepend-icon="mdi-file-image" class="custom-select" @change="onFileChange"
                            :rules="fileRules"></v-file-input>
                        </fieldset>
                        <v-img v-if="previewUrl" class="img-logo-bank" :src="previewUrl"></v-img>
                        <span v-if="
                          !bankData.methods_logo_url &&
                          errors.methods_logo_url
                        " class="error-message">{{ errors.methods_logo_url }}</span>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Bank Address*</legend>
                          <v-text-field v-model="bankData.beneficiary_bank_address" label="ENTER YOUR BANK ADDRESS" single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                        <span v-if="
                          !bankData.beneficiary_bank_address &&
                          errors.beneficiary_bank_address
                        " class="error-message">{{ errors.beneficiary_bank_address }}</span>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Bank SWIFT Code*</legend>
                          <v-text-field v-model="bankData.beneficiary_bank_swift" label="ENTER YOUR BANK SWIFT CODE" single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                        <span v-if="
                          !bankData.beneficiary_bank_swift &&
                          errors.beneficiary_bank_swift
                        " class="error-message">{{ errors.beneficiary_bank_swift }}</span>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>IBAN Number*</legend>
                          <v-text-field v-model="bankData.beneficiary_IBAN" label="N/A" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                        <span v-if="
                          !bankData.beneficiary_IBAN &&
                          errors.beneficiary_IBAN
                        " class="error-message">{{ errors.beneficiary_IBAN }}</span>
                      </v-col>
                       
                      <v-col cols="12">
                        <fieldset>
                          <legend>Beneficiary Address*</legend>
                          <v-text-field v-model="bankData.beneficiary_address" label="N/A" single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                        <span v-if="
                          !bankData.beneficiary_address &&
                          errors.beneficiary_address
                        " class="error-message">{{ errors.beneficiary_address }}</span>
                      </v-col>
                     
                      <v-col cols="12">
                        <fieldset>
                          <legend>Processing Time*</legend>
                          <v-text-field v-model="bankData.processing_time" label="3-5 Business Days" single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                        <span v-if="
                          !bankData.processing_time && errors.processing_time
                        " class="error-message">{{ errors.processing_time }}</span>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Commission(%)*</legend>
                          <v-text-field v-model="bankData.commission" type="number" label="ENTER YOUR COMMISSION %" single-line
                            solo hide-details class="custom-select"></v-text-field>
                        </fieldset>
                        <span v-if="!bankData.commission && errors.commission" class="error-message">{{
                          errors.commission }}</span>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>IFSC Code*</legend>
                          <v-text-field v-model="bankData.ifsc_code" label="ENTER YOUR IFSC CODE" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                        <span v-if="!bankData.ifsc_code && errors.ifsc_code" class="error-message">{{ errors.ifsc_code
                        }}</span>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>INR amount for 1 USD*</legend>
                          <v-text-field type="number" v-model="bankData.usd_to_inr" label="ex: 100.00" single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                        <span v-if="!bankData.usd_to_inr && errors.usd_to_inr" class="error-message">{{
                          errors.usd_to_inr }}</span>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Currency*</legend>
                          <v-select solo :items="currenciesLists" v-model="bankData.currency"
                            append-icon="mdi-chevron-down" label="Click to Select" class="custom-select"
                            hide-details></v-select>
                        </fieldset>
                        <span v-if="!bankData.currency && errors.currency" class="error-message">{{ errors.currency
                        }}</span>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card-actions>
                    <v-row dense>
                      <v-btn tile @click="submitForm" :disabled="loading" :loading="loading" elevation="0"
                        class="text-capitalize btn-account mr-3 px-sm-8" color="greenMain">Save</v-btn>
                      <v-btn tile color="#FF567F" @click="handleClose" elevation="0"
                        class="text-capitalize btn-account px-sm-8">Close</v-btn>
                    </v-row>
                  </v-card-actions>
                </v-card>

              </v-dialog>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense class="px-5">
      <v-col v-for="bank in filteredBanks" :key="bank.id" cols="12" sm="6" md="6" lg="4">
        <v-card tile flat class="pa-5 broker-account-card" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <div class="image-section">
            <v-img width="100%" :src="logoUrl(bank?.methods_logo_url)"></v-img>
          </div>
          <div class="content-details">
            <ul>
              <li>
                <span class="sub-title">Beni. Bank Name</span>
                <span class="titles">{{
                  bank.beneficiary_bank_name || "N/A"
                }}</span>
              </li>
              <li>
                <span class="sub-title">Processing Time</span>
                <span class="titles">{{ bank.processing_time }}</span>
              </li>
              <li>
                <span class="sub-title">Beneficiary Name</span>
                <span class="titles">{{ bank.beneficiary_name }}</span>
              </li>
              <li>
                <span class="sub-title">Beni. IBAN</span>
                <span class="titles">{{ bank.beneficiary_IBAN || "N/A" }}</span>
              </li>
              <li>
                <span class="sub-title">Commission</span>
                <span class="titles">{{ bank.commission }}</span>
              </li>
              <li>
                <span class="sub-title">UPI Address</span>
                <span class="titles">{{
                  bank.upi || "N/A"
                }}</span>
              </li>
            </ul>
            <ul>
              <li>
                <span class="sub-title">Currency</span>
                <span class="titles">{{ bank.currency }}</span>
              </li>
              <li>
                <span class="sub-title">Beni. Account</span>
                <span class="titles">{{
                  bank.beneficiary_account || "N/A"
                }}</span>
              </li>
              <li>
                <span class="sub-title">Bank SWIFT</span>
                <span class="titles">{{
                  bank.beneficiary_bank_swift || "N/A"
                }}</span>
              </li>
              <li>
                <span class="sub-title">Beni. Address</span>
                <span class="titles">{{ bank.beneficiary_address }}</span>
              </li>
              <li>
                <span class="sub-title">Beni. Bank Address</span>
                <span class="titles">{{
                  bank.beneficiary_bank_address || "N/A"
                }}</span>
              </li>
              
            </ul>
          </div>

          <v-dialog v-if="$canRoute('broker-account') === 1" transition="scale-transition" origin="center center" max-width="550" v-model="updateDialog[bank.id]"
            content-class="deposit-withdraw-popup marketingPopup">
            <template v-slot:activator="{ on, attrs }">
              <v-btn large tile block elevation="0" @click="editModalOpen(bank)"
                class="ma-0 text-capitalize btn-account" color="greenMain" height="48px" v-bind="attrs" v-on="on">
                Update
              </v-btn>
            </template>

            <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
              <v-card-title class="pb-3 text-left justify-start pl-3">
                Update Bank
              </v-card-title>
              <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                You Can Update Broker Bank information account from here
              </v-card-subtitle>
              <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                ">
                <v-row>
                  <v-col cols="12">
                    <fieldset>
                      <legend>Bank Name</legend>
                      <v-text-field v-model="bank.beneficiary_bank_name" label="ENTER BANK NAME" single-line solo
                        hide-details class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12">
                    <fieldset>
                      <legend>Account Holder Name</legend>
                      <v-text-field v-model="bank.beneficiary_name" label="ENTER ACCOUNT HOLDER NAME" single-line solo
                        hide-details class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                   <v-col cols="12">
                    <fieldset>
                      <legend>UPI Address</legend>
                      <v-text-field v-model="bank.upi" label="BANK UPI Address" single-line solo
                        hide-details class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                   <v-col cols="12">
                    <fieldset>
                      <legend>Account Number</legend>
                      <v-text-field v-model="bank.beneficiary_account" label="ENTER BANK ACCOUNT NUMBER" single-line solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                   <v-col cols="12" sm="12" md="12" lg="12">
                    <fieldset>
                      <legend>Bank Country*</legend>
                      <v-autocomplete v-model="bankData.countryAccess"
                        :items="[{ id: 'all', name: 'All Countries' }, ...countries]" label="Country Access"
                        item-text="name" item-value="id" multiple chips deletable-chips single-line solo
                        class="custom-select">
                      </v-autocomplete>
                      <span v-if="errors.countryAccess" style="color: red; font-size: 12px">
                        {{ errors.countryAccess }}
                      </span>
                    </fieldset>
                  </v-col>
                  <v-col cols="12">
                    <fieldset>
                      <legend>Bank Logo</legend>
                      <v-file-input v-model="methods_logo_url" label="Choose file (Max Size 2MB)" single-line solo
                        prepend-icon="mdi-file-image" class="custom-select" @change="onFileChange2"
                        :rules="fileRules"></v-file-input>
                    </fieldset>

                    <v-img class="img-logo-bank" :src="bank.methods_logo_url || previewUrl2"></v-img>

                    <span v-if="!bank.methods_logo_url && errors.methods_logo_url" class="error-message">{{
                      errors.methods_logo_url }}</span>
                  </v-col>
                   <v-col cols="12">
                    <fieldset>
                      <legend> Bank Address</legend>
                      <v-text-field v-model="bank.beneficiary_bank_address" label="ENTER BANK ADDRESS" single-line solo
                        hide-details class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12">
                    <fieldset>
                      <legend>Bank SWIFT</legend>
                      <v-text-field v-model="bank.beneficiary_bank_swift" label="ENTER BANK SWIFT NUMBER" single-line solo
                        hide-details class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                 
                  <v-col cols="12">
                    <fieldset>
                      <legend>BANK IBAN</legend>
                      <v-text-field v-model="bank.beneficiary_IBAN" label="N/A" single-line solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12">
                    <fieldset>
                      <legend>Beneficiary Address</legend>
                      <v-text-field v-model="bank.beneficiary_address" label="N/A" single-line solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12">
                    <fieldset>
                      <legend>Processing Time</legend>
                      <v-text-field v-model="bank.processing_time" label="3-5 Business Days" single-line solo
                        hide-details class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12">
                    <fieldset>
                      <legend>Commission(%)</legend>
                      <v-text-field v-model="bank.commission" type="number" label="ENETR COMMISSION" single-line solo
                        hide-details class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12">
                    <fieldset>
                      <legend>IFSC Code</legend>
                      <v-text-field v-model="bank.ifsc_code" label="ENTER IFSC CODE" single-line solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12">
                    <fieldset>
                      <legend>INR amount for 1 USD</legend>
                      <v-text-field v-model="bank.usd_to_inr" label="ex: 100.00" single-line solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12">
                    <fieldset>
                      <legend>Currency</legend>
                      <v-select solo :items="currenciesLists" v-model="bank.currency" append-icon="mdi-chevron-down"
                        :label="bank.currency || 'Click to Select'" class="custom-select" hide-details></v-select>
                    </fieldset>
                  </v-col>
                </v-row>
              </v-card>
              <v-card-actions>
                <v-row dense>
                  <v-btn tile @click="updateForm(bank)" :loading="loading" :disbled="loading" elevation="0"
                    class="text-capitalize btn-account mr-3 px-sm-8" color="greenMain">Save</v-btn>
                  <v-btn tile color="#FF567F" @click="handleUpdateClose(bank)" elevation="0"
                    class="text-capitalize btn-account px-sm-8">Close</v-btn>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { BROKERSBANK__ACTIONS, COUNTRIES__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      search: "",
      dialog: false,
      loading: false,
      methods_logo_url: null,
      update_country: [],
      updateDialog: {},
      fileRules: [
        (value) =>
          !value || value.size < 2000000 || "File size should be less than 2MB",
      ],
      bankData: {
        currency: "",
        commission: "",
        processing_time: "",
        beneficiary_name: "",
        beneficiary_address: "",
        beneficiary_account: "",
        beneficiary_IBAN: "",
        beneficiary_bank_name: "",
        beneficiary_bank_address: "",
        beneficiary_bank_swift: "",
        ifsc_code: "",
        usd_to_inr: "",
        methods_logo_url: null,
        countryAccess: "",
        upi:"",
      },
      fileError: false,
      previewUrl: null,
      previewUrl2: null,
      errors: {
        usd_to_inr: "",
        currency: "",
        commission: "",
        processing_time: "",
        beneficiary_name: "",
        beneficiary_address: "",
        beneficiary_account: "",
        beneficiary_IBAN: "",
        beneficiary_bank_name: "",
        beneficiary_bank_address: "",
        beneficiary_bank_swift: "",
        ifsc_code: "",
        methods_logo_url: "",
        countryAccess: "",
        UPI:"",
      },
    };
  },

  computed: {
    ...mapState("brokersbank", ["banks", "currencies"]),
    ...mapState("admins", ["loggedAdmin"]),
    ...mapState("countries", ["countries"]),
    
    currenciesLists() {
      return this.currencies.map((x) => x?.currency_name);
    },

    filteredBanks() {
      const searchLower = this.search.toLowerCase();
      return this.banks?.filter((bank) => {
        return (
          bank?.beneficiary_name
            ?.toString()
            ?.toLowerCase()
            ?.includes(searchLower) ||
          bank?.beneficiary_bank_name
            ?.toString()
            ?.toLowerCase()
            ?.includes(searchLower) ||
          bank?.beneficiary_account
            ?.toString()
            ?.toLowerCase()
            ?.includes(searchLower) ||
          bank?.beneficiary_IBAN
            ?.toString()
            ?.toLowerCase()
            ?.includes(searchLower) ||
          bank?.beneficiary_address
            ?.toString()
            ?.toLowerCase()
            ?.includes(searchLower) ||
          bank?.beneficiary_bank_address
            ?.toLowerCase()
            ?.includes(searchLower) ||
          bank?.beneficiary_bank_swift
            ?.toString()
            ?.toLowerCase()
            ?.includes(searchLower) ||
          bank?.ifsc_code?.toString()?.toLowerCase()?.includes(searchLower) ||
          bank?.usd_to_inr?.toString()?.toLowerCase()?.includes(searchLower) ||
          bank?.currency?.toString()?.toLowerCase()?.includes(searchLower) ||
          bank?.commission?.toString()?.toLowerCase()?.includes(searchLower) ||
          bank?.processing_time
            ?.toString()
            ?.toLowerCase()
            ?.includes(searchLower)
        );
      });
    },
  },

  methods: {
    ...mapActions("brokersbank", [
      BROKERSBANK__ACTIONS.GETBROKERSBANK,
      BROKERSBANK__ACTIONS.BROKERSBANK,
      BROKERSBANK__ACTIONS.GETCURRENCIES,
      BROKERSBANK__ACTIONS.UPDATEBANK,
    ]),

    ...mapActions("countries", [
      COUNTRIES__ACTIONS.COUNTRIES,
    ]),

    logoUrl(url) {
      return url || require("@/assets/bank.png");
    },

    handleCountrySelection(selection) {
      if (!selection) {
        this.bankData.countryAccess = [];
        return;
      }

      // If "All" is selected, clear other selections
      if (selection.includes('all')) {
        this.bankData.countryAccess = ['all'];
        return;
      }

      // Remove 'all' if other countries are selected
      this.bankData.countryAccess = selection.filter(item => item !== 'all');
    },

    editModalOpen(bank) {
      this.bankData.countryAccess = "";
      this.methods_logo_url = null;
      const ids = String(bank.country_access || '')
        .split(',')
        .map(id => id.trim());

      this.update_country = ids.map(id =>
        id === 'all'
          ? { id: 'all', name: 'All Countries' }
          : this.countries.find(c => String(c.id) === id)
      ).filter(Boolean)
    },

    onFileChange(file) {
      if (file && file.size < 2000000) {
        this.bankData.methods_logo_url = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.bankData.methods_logo_url = null;
        this.previewUrl = null;
        this.fileError = true;
        this.errors.methods_logo_url = "File size should be less than 2MB";
      }
    },

    onFileChange2(file) {
      if (file && file.size < 2000000) {
        this.methods_logo_url = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewUrl2 = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.methods_logo_url = null;
        this.previewUrl2 = null;
        this.fileError = true;
        this.errors.methods_logo_url = "File size should be less than 2MB";
      }
    },

    async submitForm() {
      this.errors = {
        usd_to_inr: "",
        currency: "",
        commission: "",
        processing_time: "",
        beneficiary_name: "",
        beneficiary_address: "",
        beneficiary_account: "",
        beneficiary_IBAN: "",
        beneficiary_bank_name: "",
        beneficiary_bank_address: "",
        beneficiary_bank_swift: "",
        ifsc_code: "",
        methods_logo_url: "",
        countryAccess: "",
        upi:"",
      };

      const requiredFields = {
        usd_to_inr: "USD to INR conversion rate",
        currency: "Currency",
        commission: "Commission",
        processing_time: "Processing time",
        beneficiary_name: "Account holder name",
        beneficiary_address: "Beneficiary address",
        beneficiary_account: "Account holder number",
        beneficiary_IBAN: "IBAN",
        beneficiary_bank_name: "Bank name",
        beneficiary_bank_address: "Bank address",
        beneficiary_bank_swift: "Bank SWIFT",
        ifsc_code: "IFSC code",
        methods_logo_url: "Bank logo",
        countryAccess: "Country",
        upi: "UPI ID"
      };

      // Validate required fields
      Object.keys(requiredFields).forEach((field) => {
        if (!this.bankData[field]) {
          this.errors[field] = `${requiredFields[field]} is required`;
        }
      });

      // Handle file size error
      if (this.fileError) {
        this.errors.methods_logo_url = "File size should be less than 2MB";
        return;
      }

      // Check if there are any errors
      const hasErrors = Object.values(this.errors).some(
        (error) => error !== ""
      );

      // Submit form if there are no errors
      const formattedCountryAccess = this.bankData.countryAccess.includes('all')
        ? this.countries.map(country => country.id).join(',')
        : this.bankData.countryAccess.join(',');

      try {
        if (!hasErrors) {
          this.loading = true;
          await this[BROKERSBANK__ACTIONS.BROKERSBANK]({
            usd_to_inr: this.bankData.usd_to_inr,
            currency: this.bankData.currency,
            commission: this.bankData.commission,
            processing_time: this.bankData.processing_time,
            beneficiary_name: this.bankData.beneficiary_name,
            beneficiary_address: this.bankData.beneficiary_address,
            beneficiary_account: this.bankData.beneficiary_account,
            beneficiary_IBAN: this.bankData.beneficiary_IBAN,
            beneficiary_bank_name: this.bankData.beneficiary_bank_name,
            beneficiary_bank_address: this.bankData.beneficiary_bank_address,
            beneficiary_bank_swift: this.bankData.beneficiary_bank_swift,
            ifsc_code: this.bankData.ifsc_code,
            methods_logo_url: this.bankData.methods_logo_url,
            country_access: formattedCountryAccess,
            upi: this.bankData.upi,
          });
        }
      } catch (error) {
        console.error("Error:", error);
        this.loading = false;
      } finally {
        this.loading = false;
        this.handleClose();
      }

    },

    async updateForm(item) {

      if(!this.bankData.countryAccess){
        this.errors.countryAccess= "Please select bank country access.";
        return;
      }

      if (this.fileError) {
        this.errors.methods_logo_url = "File size should be less than 2MB";
      } else {
        this.loading = true;
        let formattedCountryAccess = '';

        if (Array.isArray(this.bankData.countryAccess) && this.bankData.countryAccess.length > 0) {
          const selectedIds = this.bankData.countryAccess.map(c => c?.id || c); // support both id or full object

          const hasAll = selectedIds.includes('all');

          formattedCountryAccess = hasAll
            ? this.countries.map(c => c.id).join(',')
            : selectedIds.filter(id => id && id !== 'all').join(',');
        }

        try {
          await this[BROKERSBANK__ACTIONS.UPDATEBANK]({
            id: item.id,
            usd_to_inr: item.usd_to_inr,
            currency: item.currency,
            commission: item.commission,
            processing_time: item.processing_time,
            beneficiary_name: item.beneficiary_name,
            beneficiary_address: item.beneficiary_address,
            beneficiary_account: item.beneficiary_account,
            beneficiary_IBAN: item.beneficiary_IBAN,
            beneficiary_bank_name: item.beneficiary_bank_name,
            beneficiary_bank_address: item.beneficiary_bank_address,
            beneficiary_bank_swift: item.beneficiary_bank_swift,
            ifsc_code: item.ifsc_code,
            methods_logo_url: item.methods_logo_url,
            country_access: formattedCountryAccess,
            newFile: this.methods_logo_url,
            upi : item.upi,
          });
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false;
          this.handleUpdateClose(item);
        }
      }
    },

    clear(){
      this.errors= {};
      this.bankData.countryAccess = "";
      this.methods_logo_url = null;
      this.loading = false;
    },

    handleClose() {
      this.dialog = false;
      this.fileError = false;
      this.previewUrl = null;
      this.errors = {
        usd_to_inr: "",
        currency: "",
        commission: "",
        processing_time: "",
        beneficiary_name: "",
        beneficiary_address: "",
        beneficiary_account: "",
        beneficiary_IBAN: "",
        beneficiary_bank_name: "",
        beneficiary_bank_address: "",
        beneficiary_bank_swift: "",
        ifsc_code: "",
        methods_logo_url: "",
        countryAccess : "",
        upi : ""
      };
      this.bankData = {
        currency: "",
        usd_to_inr: "",
        commission: "",
        processing_time: "",
        beneficiary_name: "",
        beneficiary_address: "",
        beneficiary_account: "",
        beneficiary_IBAN: "",
        beneficiary_bank_name: "",
        beneficiary_bank_address: "",
        beneficiary_bank_swift: "",
        ifsc_code: "",
        methods_logo_url: null,
        countryAccess: null,
        upi : ""
      };
    },

    handleUpdateClose(item) {
      this.$set(this.updateDialog, item?.id, false);
      this.fileError = false;
    },
  },

  async created() {
    this[COUNTRIES__ACTIONS.COUNTRIES]();
    this[BROKERSBANK__ACTIONS.GETBROKERSBANK]();
    this[BROKERSBANK__ACTIONS.GETCURRENCIES]();
  },
};
</script>

<style scoped>
.error-message {
  color: red;
  /* Example styling for error messages */
  font-size: 14px;
  margin-top: 5px;
  margin-top: 4px;
}

.img-logo-bank {
  margin-top: 15px;
  width: 150px;
  height: auto;
  margin-left: 0 auto;
}
</style>
